import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import * as Sentry from '@sentry/react';
import './index.css';

import { routeTree } from './routeTree.gen';

const isSentryDisabled =
  import.meta.env.SENTRY_DISABLED === 'true' ||
  import.meta.env.SENTRY_DISABLED === true;

if (!isSentryDisabled) {
  Sentry.init({
    dsn: 'https://55bd2eee59e9758d8b22a879d851e525@sentry.iveitteam.hu/45',
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
